'use strict';
module.exports = function ConfirmationSender(params) {
	const self = this,
		{storage, goldApi, authenticationModel, source} = params,
		licenseAction = function (apiAction, params) {
			return authenticationModel.getLicense()
				.then((license) => {
					return goldApi.exec(apiAction, Object.assign({}, params, {license: license}));
				});
		},
		calculateConfirmationType = (reportingDate, lastReportedDate) => {
			if (!lastReportedDate) {
				return 1;
			}
			if (reportingDate.getUTCFullYear() !== lastReportedDate.getUTCFullYear()) {
				return 1;
			}
			if (reportingDate.getUTCMonth() !== lastReportedDate.getUTCMonth()) {
				return 1;
			}
			if (reportingDate.getUTCDate() !== lastReportedDate.getUTCDate()) {
				return 2;
			}
			return false;
		};
	if (!storage || !goldApi || !authenticationModel) {
		throw new Error('invalid-args');
	}
	self.confirm = async (confirmationMessage) => {
		const storageKey = `confirm-${confirmationMessage}`,
			reportingDate = new Date(),
			reportingTimestamp = reportingDate.getTime(),
			existingConfirmations = storage.getItem(storageKey) || {},
			lastDate = existingConfirmations && existingConfirmations.last && new Date(existingConfirmations.last),
			since = existingConfirmations.since || reportingTimestamp,
			confirmationType = calculateConfirmationType(reportingDate, lastDate);
		if (!confirmationType) {
			return;
		}
		await licenseAction(`confirm/${confirmationMessage}/${confirmationType}`, {
			since: Math.floor(since / 1000),
			source: source
		});
		storage.setItem(storageKey, {
			since: since,
			last: reportingTimestamp
		});
	};
};




